import React from 'react'
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import { Link, useNavigate } from "react-router-dom";

const Page2 = (props) => {
  let classOptions = [];
  if (props.applicant.gender === 'Boy') {
    classOptions = [
      <option key="" value="">Select</option>,
      <option key="gps" value="gps">Government Primary School</option>,
      <option key="ghs" value="ghs">Government High School</option>,
      <option key="gcs" value="gcs">Government Community School</option>,
      <option key="gms" value="gms">Government Middle School</option>
    ];
  } else {
    classOptions = [
      <option key="" value="">Select</option>,
      <option key="ggps" value="ggps">Government Primary School</option>,
      <option key="gghs" value="gghs">Government High School</option>,
      <option key="ggcs" value="ggcs">Government Community School</option>,
      <option key="ggms" value="ggms">Government Middle School</option>
    ];
  }

  const onChange = (e) => {
    props.setApplicant({ ...props.applicant, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Your existing validation logic remains untouched
    if (props.applicant.class1.length < 3) {
      toastr.error("Class 1 must be selected");
      document.querySelector("#class1").focus();
      return;
    }
    else if (props.applicant.class1address.length < 3) {
      toastr.error("School Address must be provided");
      document.querySelector("#class1address").focus();
      return;
    }
    else if (props.applicant.class2.length < 3) {
      toastr.error("Class 2 must be Selected");
      document.querySelector("#class2").focus();
      return;
    }
    else if (props.applicant.class2address.length < 3) {
      toastr.error("School Address must be provided");
      document.querySelector("#class2address").focus();
      return;
    }
    else if (props.applicant.class3.length < 3) {
      toastr.error("Class 3 must be Selected");
      document.querySelector("#class3").focus();
      return;
    }
    else if (props.applicant.class3address.length < 3) {
      toastr.error("School Address must be provided");
      document.querySelector("#class3address").focus();
      return;
    }
    else if (props.applicant.class4.length < 3) {
      toastr.error("Class 4 must be Selected");
      document.querySelector("#class4").focus();
      return;
    }
    else if (props.applicant.class4address.length < 3) {
      toastr.error("School Address must be provided");
      document.querySelector("#class4address").focus();
      return;
    }
    else if (props.applicant.class5.length < 3) {
      toastr.error("Class 5 must be Selected");
      document.querySelector("#class5").focus();
      return;
    }
    else if (props.applicant.class5address.length < 3) {
      toastr.error("School Address must be provided");
      document.querySelector("#class5address").focus();
      return;
    }
    else if (props.applicant.class6.length < 3) {
      toastr.error("Class 6 must be Selected");
      document.querySelector("#class6").focus();
      return;
    }
    else if (props.applicant.class6address.length < 3) {
      toastr.error("School must be Selected");
      document.querySelector("#class6address").focus();
      return;
    }

    props.setStep2(false);
    props.setStep3(true);
  };

  return (
    <div className="container form-xs" style={{ padding: '20px', backgroundColor: '#fdfdfd' }}>
      <style>{`
        .form-control { border-radius: 4px !important; border: 1px solid #ccc !important; height: 40px !important; }
        .form-group { margin-bottom: 20px; }
        .control-label { font-weight: 600; color: #333; }
        .new-urdu { float: right; color: #2e7d32; font-size: 15px; }
        .mandatory { color: red; margin: 0 5px; }
        .step-circle-active { background-color: #28a745 !important; color: white !important; border: 2px solid #28a745 !important; }
        .step-circle-default { background-color: #eee !important; color: #777 !important; border: 2px solid #ccc !important; }
        .btn-circle-custom {
          width: 40px; height: 40px; border-radius: 50%; display: inline-flex; 
          align-items: center; justify-content: center; text-decoration: none;
          font-weight: bold; transition: all 0.3s;
        }
        .save-btn {
          background-color: #007bff; color: white; border: none; 
          padding: 10px 40px; border-radius: 5px; font-size: 16px; font-weight: bold;
          cursor: pointer;
        }
        .prev-btn {
          background-color: #6c757d; color: white; border: none; 
          padding: 10px 40px; border-radius: 5px; font-size: 16px; font-weight: bold;
          margin-right: 10px; cursor: pointer;
        }
        .is-invalid { border-color: #dc3545 !important; box-shadow: 0 0 0 0.2rem rgba(220,53,69,.25) !important; }
        .is-valid { border-color: #28a745 !important; }
      `}</style>

      {/* Header */}
      <div className="col-xs-12 col-sm-12 col-md-12 hidden-xs" style={{ marginBottom: 20 }}>
        <div>
          <h6 className="page-heading" style={{ fontSize: '20px', fontWeight: 'bold' }}>Application Form for Scholarship/Admission in Class 7th in Centers of Excellence</h6>
          <p className="page-sub-heading" style={{ color: '#666' }}>Under the scheme provision of Free &amp; Quality Education for Talented Students of Government Schools of Khyber Pakhtunkhwa</p>
        </div>
      </div>

      {/* Step Wizard Mobile */}
      <div className="stepwizard hidden-sm hidden-md hidden-lg" style={{ marginBottom: '20px' }}>
        <div className="stepwizard-row setup-panel" style={{ display: 'flex', justifyContent: 'space-around' }}>
          <div className="stepwizard-step">
            <a href="#step-1" className={`btn-circle-custom ${props.step1 ? "step-circle-active" : "step-circle-default"}`}>1</a>
          </div>
          <div className="stepwizard-step">
            <a href="#step-2" className={`btn-circle-custom ${props.step2 ? "step-circle-active" : "step-circle-default"}`}>2</a>
          </div>
          <div className="stepwizard-step">
            <a href="#step-3" className={`btn-circle-custom ${props.step3 ? "step-circle-active" : "step-circle-default"}`}>3</a>
          </div>
        </div>
      </div>

      {/* Step Wizard Desktop */}
      <div className="stepwizard hidden-xs" style={{ marginBottom: '30px' }}>
        <div className="stepwizard-row setup-panel" style={{ display: 'flex', textAlign: 'center' }}>
          <div className="stepwizard-step" style={{ flex: 1 }}>
            <a href="#step-1" onClick={() => { props.setStep2(false); props.setStep1(true) }} className={`btn-circle-custom ${props.step1 ? "step-circle-active" : "step-circle-default"}`}>1</a>
            <p><small>Personal Information</small></p>
          </div>
          <div className="stepwizard-step" style={{ flex: 1 }}>
            <a href="#step-2" className={`btn-circle-custom ${props.step2 ? "step-circle-active" : "step-circle-default"}`}>2</a>
            <p><small>Name of Institution/School</small></p>
          </div>
          <div className="stepwizard-step" style={{ flex: 1 }}>
            <a href="#step-3" onClick={handleSubmit} className={`btn-circle-custom ${props.step3 ? "step-circle-active" : "step-circle-default"}`}>3</a>
            <p><small>Desired Institution in order of Preference</small></p>
          </div>
        </div>
      </div>

      <form id="form3" onSubmit={handleSubmit}>
        <div className="z-depth-1 white col s12 l9 m8 offset-s0 offset-l2 offset-m3 form-container" style={{ background: '#fff', padding: '25px', borderRadius: '10px', boxShadow: '0 2px 15px rgba(0,0,0,0.08)' }}>
          <div className="panel setup-content" id="step-2">
            <h5 className="page-heading" style={{ borderBottom: '2px solid #eee', paddingBottom: '10px', marginBottom: '20px' }}>Name of Institution/School</h5>
            <div className="panel-body row">

              {[1, 2, 3, 4, 5, 6].map((num) => {
                const urduClasses = ["اول", "دوم", "سوم", "چہارم", "پنجم", "ششم"];
                const engClasses = ["One", "Two", "Three", "Four", "Five", "Six"];
                return (
                  <React.Fragment key={num}>
                    <div className="form-group col-xs-12 col-sm-6 padding-xs-0">
                      <label className="control-label label-english">Class {engClasses[num - 1]}:</label>
                      <span className="mandatory">*</span>
                      <label className="new-urdu">جماعت {urduClasses[num - 1]}</label>
                      <select
                        className="form-control"
                        id={`class${num}`}
                        name={`class${num}`}
                        value={props.applicant[`class${num}`]}
                        onChange={onChange}
                      >
                        {classOptions}
                      </select>
                    </div>
                    <div className="form-group col-xs-12 col-sm-6 padding-xs-0">
                      <label className="control-label label-english">School Address</label>
                      <span className="mandatory">*</span>
                      <label className="new-urdu">سکول کا پتہ</label>
                      <input
                        id={`class${num}address`}
                        name={`class${num}address`}
                        value={props.applicant[`class${num}address`]}
                        onChange={onChange}
                        maxLength={200}
                        type="text"
                        className="form-control"
                        placeholder="Hint: Mohalla/Village Union Council City/District"
                      />
                    </div>
                  </React.Fragment>
                );
              })}

              <div className="col-xs-12" style={{ textAlign: 'center', marginTop: 30, borderTop: '1px solid #eee', paddingTop: '20px' }}>
                <button
                  className="prev-btn"
                  type="button"
                  onClick={() => { props.setStep2(false); props.setStep1(true) }}
                >
                  Previous
                </button>
                <button type="submit" className="save-btn">Save & Next</button>
              </div>

            </div>
          </div>
        </div>
      </form>
    </div>
  )
}

export default Page2;